import React = require("react");
import { ThemedQuestionList } from "./ThemedQuestionList";
import { LanguageCode, stringUtil } from '../../../amorg-common';
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { Button } from "../../../designSystem/button/Button";
import { createSurveyTheme } from "../../../api/surveyClientApi";
import { Survey, getAllIndicators, surveyHelper, getSurveyStatus } from '../../../amorg-common';
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";

type ThemeListProps = {
    survey: Survey,
    languageCode:LanguageCode,
    onSurveyUpdated: () => void,
}

export function ThemeList(props: ThemeListProps): JSX.Element {

    async function handleClickAddNewTheme() {
        const name = stringUtil.generateNextSequenceName('Nyt tema', props.survey.themes.map(t => t.name));
        if (await createSurveyTheme(props.survey.id, name))
            props.onSurveyUpdated();
    }

    const allIndicators = getAllIndicators(props.survey);
    const disableEdit = !getSurveyStatus(props.survey).canEdit;

    return (
        <Flex gap={24} flexDirection="column">
            {/* <H4>Spørgsmål fordelt på tema</H4> */}
            {props.survey.themes.map((t, i) => {
                return (
                    <Flex key={t.name} flexDirection="column">
                        <ThemedQuestionList
                            survey={props.survey}
                            themes={props.survey.themes}
                            theme={t}
                            themeIndex={i}
                            allIndicators={allIndicators}
                            languageCode={props.languageCode}
                            onSurveyUpdated={props.onSurveyUpdated}
                        />
                    </Flex>
                );
            })}
            {surveyHelper.getAllSurveyQuestions(props.survey).length === 0 &&
                <p>
                    Der er ikke oprettet spørgsmål for undersøgelsen
                </p>
            }
            <ButtonRow variant="stretched">
                <Button
                    variant="outlined" size='magnum'
                    onClick={handleClickAddNewTheme}
                    icon="actions_plus"
                    text={"Tilføj tema"}
                    disabled={disableEdit} />
            </ButtonRow>
        </Flex>
    );
}